import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  card: {
    elevation: 4,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    alignSelf: "center",
    width: "87.5%",
    height: "91.25%",
    justifyContent: "center",
    paddingHorizontal: "6vw",
  },
});
